<action-box *ngIf="visible" textLeft="{{strings.Reports}}" [showHeader]="showHeader">
  <ng-container *ngFor="let report of reportValues">
    <div class="menu-item justify-content-between" title="{{report.title}}">
      <custom-link [isRemote]="false" [url]="report.link" [title]="report.title" [extraStyles]="'py-2'" [icon]="report.icon" [targetSelf]="true" [imageSet]="imageSet"></custom-link>
    </div>
  </ng-container>
</action-box>